import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M25.756 10.746a15.97 15.97 0 0 0-13.07 4.59c-6.248 6.25-6.248 16.38 0 22.628 6.249 6.249 16.38 6.249 22.628 0 6.248-6.248 6.248-16.379 0-22.627a1 1 0 0 1 1.414-1.414c7.03 7.029 7.03 18.426 0 25.455-7.03 7.03-18.427 7.03-25.456 0-7.03-7.029-7.03-18.426 0-25.455a17.969 17.969 0 0 1 14.653-5.17 1.51 1.51 0 0 0-.138-.159l-3.885-3.887a1 1 0 1 1 1.414-1.414l3.885 3.887a3.5 3.5 0 0 1 .002 4.948l-3.872 3.878a1 1 0 0 1-1.416-1.413l3.841-3.847Z",
      clipRule: "evenodd"
    }
  )
);
var SvgRefreshOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RefreshOutlined_default = SvgRefreshOutlined;

export { RefreshOutlined_default as default };
